/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_What_HInputs */

const en_wc_what_h = /** @type {(inputs: Wc_What_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is WordCraft?`)
};

/**
* | output |
* | --- |
* | "What is WordCraft?" |
*
* @param {Wc_What_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_what_h = /** @type {((inputs?: Wc_What_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_What_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_what_h(inputs)
});
export { wc_what_h as "wc.what.h" }